import { render, staticRenderFns } from "./figureIdSelect.vue?vue&type=template&id=2ed591ff&"
import script from "./figureIdSelect.vue?vue&type=script&lang=js&"
export * from "./figureIdSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports